import { Link } from "react-router-dom"; 
import CollapseSection from "../../components/CollapseSection/CollapseSection";
import CollapseSectionSimple from "../../components/CollapseSectionSimple/CollapseSectionSimple";
import ModalImage from "react-modal-image";

import classes from "./styles.scss";

const data = [
	{
		title: "Ден 1",
		date: "26 / 27 ноември 2022",
		destination: "София – Мексико сити",
		others: "",
		text: <div>Ще започнем нашето приключение на летище София, където ще ни очаква водачът на групата. Заминаване за Мексико сити с прекачване в Истанбул. Ще кацнем на международното летище в мексиканската столица (на следващия ден, 27.11.2022 г.). Местният екскурзовод ще ни посрещне и отведе до историческия център, за да закусим. Панорамна обиколка на Мексико сити, която включва Сокало или Площада на Конституцията, най-големият в Латинска Америка, където е разположена Катедралата и Националният дворец със стенописи на Диего Ривера. Ще стигнем и до очарователния Дворец на изящните изкуства, една от емблемите на града. Панорамната ни обиколка ще продължи по централния булевард Реформа и парка Чапултепек. Посещение на Антропологическия музей. Ще завършим в квартала Сочимилко, известен с изкуствено създадените в езеро острови, наречени чинампас. Там ще поплаваме на т.нар. “трахинерас”, традиционни лодки, украсени с цветя, които ловко маневрират край плаващите градини. Възможно е дори да чуем групи от мариачи, които също плават по каналите. Ще срещнем и търговци на вкусна домашна храна, които я продават директно от лодките си. Спокойно можем да кажем, че това е мексиканската Венеция. Трансфер до хотела, настаняване в <a className={classes.textLink} href="https://www.lailahotels.com" target="_blank"> Laila Reforma 4*</a> или подобен в сърцето на мексиканската столица. Свободно време.</div>
	}, 
	{
		title: "Ден 2",
		date: "28 ноември 2022",
		destination: "Мексико сити – базиликата Гуадалупе – Теотиуакан – Мексико сити",
		others: "(обяд)",
		text: <div>След закуска ще се отправим към Площада на трите култури в квартал Тлателолко. Тук са разположени руините на древен ацтекски храм, католическа катедрала и модерно здание.След това ще се насочим към базиликата на Гуадалупе, най-голямото католическо светилище в Мексико и второ по големина в света. Ще посетим смайващия храмов комплекс Теотиуакан, “където хората се превръщат в богове”. Ще разгледаме храма на Кетцалкуатл, Булеварда на мъртвите, пирамидите на Слънцето и Луната и храма на Кетцал-Папалотл. Ще отделим време и на една занаятчийска работилница за обсидиан и други полускъпоценни камъни, от които древните са произвеждали украшения. Ще разберем и каква е разликата между растенията магуей, агаве и хенекей. Обяд. Следобед ще се върнем в Мексико сити и ще имаме време отново да се насладим на историческия център и шумния булевард Реформа. Нощувка.</div>
	},
	{
		title: "Ден 3",
		date: "29 ноември 2022",
		destination: "Мексико сити – Тустла Гутиерес – каньон Сумидеро – Чиапа де Корсо - Сан Кристобал де лас Касас",
		others: "",
		text: <div>Закуска (поради по-ранното отлитане е възможно закуската да бъде сух пакет) и трансфер до международното летище на Мексико сити за вътрешен полет до Тустла Гутиерес, столица на щата Чиапас (полетът трае около час и половина). След като кацнем ще се отправим към внушителния каньон Сумидеро, разположен на река Грихалва, чийто отвесни скали достигат до 1000 метра. Тук ще направим и едно незабравимо пътешествие с лодки, за да опознаем по-добре това чудо на природата. Преди да се отправим към Сан Кристобал де лас Касас, едно от най-колоритните селища на Чиапас, ще се разходим из градчето Чиапа де Корсо. Настаняване в хотел <a className={classes.textLink} href="https://www.hotelcasamexicana.com/" target="_blank">Casa Mexicana 4*</a> или подобен. Нощувка.</div>
	}, 
	{
		title: "Ден 4",
		date: "30 ноември 2022",
		destination: "Сан Кристобал де лас Касас – Сан Хуан Чамула – Синакантан – Сан Кристобал де лас Касас",
		others: "",
		text: <div>Закуска в хотела. Днес ще опознаем индианските общности, които населяват тези земи. За целта ще се отправим към селищата Сан Хуан Чамула и Синакантан, където местните автентични племена са запазили езика, културата и религиозните си вярвания. Впечатяващи са техните църкви, в които съжителстват езически и християнски култове, колоритните им дрехи, къщи и оживени пазари. Следобед ще се върнем в Сан Кристобал, за да посетим традиционен пазар, катедралата, музея на билките и Музея на нефрита с реплика на гроба на цар Пакал. Нощувка.</div>
	},
	{
		title: "Ден 5",
		date: "01 декември 2022",
		destination: "Сан Кристобал де лас Касас – Агуа асул – Паленке",
		others: "",
		text: <div>След закуска в хотела ще се насочим към живописните полупланински пътища на щата Чиапас и водопадите Агуа асул (синя вода), които впечатляват с тюркоазените си води. Ако времето позволява, ще се отбием и до водопада Мисол-ха. Пристигане в Паленке. Настаняване във <a className={classes.textLink} href="https://www.hotelesvillamercedes.com/en/Menu/Homepage.aspx" target="_blank">Villa Mercedes 4*</a> или пободен. Нощувка.</div>
	},
	{
		title: "Ден 6",
		date: "02 декември 2022",
		destination: "Паленке – Кампече",
		others: "",
		text: <div>Закуска в хотела. Днес денят ни ще е посветен на археологическата зона Паленке, един от най-впечатляващите и значими градове на маите, не само заради архитектурата си, но и заради красотата на джунглата, която го обгръща. Във вътрешността на основната пирамида е открит саркофагът на цар Пакал, богато декориран с барелефи. Владетелят е бил покрит с нефритена маска. Ще видим още двореца и храма на Слънцето. След това вълнуващо посещение се отправяме към красивото крайбрежие на Мексиканския залив, а крайната ни точка за деня е Кампече, единственият укрепен град в Мексико. Настаняване в <a className={classes.textLink} href="https://hotelplazacampeche.com-hotel.com/" target="_blank">Plaza Campeche 4*</a> или подобен. Настаняване и свободно време.</div>
	},
	{
		title: "Ден 7",
		date: "03 декември 2022",
		destination: "Кампече – Ушмал – Мерида",
		others: "",
		text: <div>Закуска в хотела и панорамна обиколка на историческия център на Кампече. По-късно ще се насочим към Ушмал, един от най-важните градове на маите в Юкатан от техния последен период. Ще посетим Пирадимата на гадателите, Двореца на управителя, Игрището за топка и др. Продължаваме към Мерида, известен като “Белия град”. Това е най-големият град на полуостров Юкатан и исторически център на региона през колониалния период. Градът впечатлява с колониалната си архитектура в ренесансов и бароков стил от XVI – XVIII век, които съжителстват в симбиоза с елегантни сгради в стил бел епок и арт нуво със силно френско влияние от края на XIX век, обитавани от местната буржоазия. Няма как човек да не се влюби в това романтично място. Панорамната ни обиколка вкючва историческия център с площада, катедралата (най-старата в Мексико) и Двореца на губернатора. След това ще се отправим към елегантния булевард Монтехо, за да се снимаме на Паметника на Родината. Настаняване във <a className={classes.textLink} href="https://www.wyndhamhotels.com/wyndham/merida-mexico/wyndham-merida/overview" target="_blank"> Wyndham Garden Merida 4*</a> или подобен. Нощувка.</div>
	},
	{
		title: "Ден 8",
		date: "04 декември 2022",
		destination: "Мерида – Чичен Итца – Ривиера Майя ",
		others: "(обяд и вечеря от ALL INCLUSIVE)",
		text: <div>Закуска в хотела. Днес ще посетим Чичен Итца, най-известния и посещаван древен град на маите в Мексико. Тук, на това впечатляващо място ясно се отличава строителният и астрономически гений на древните маи. В центъра му се издига El Castillo или Пирамидата на Кукулкан, най-емблематичната сграда в града. Ще видим също El Caracol или Обсерваторията, най-голямото игрище за игра с топка, Платформата с черепите, Храма на ягуарите, площада на 1000-те колони и свещения кладенец, използван за жертвоприношения. След това ще се отправим към един от най-известните сеноте, подземен кладенец, Ik-il, в който дори може да се плува. Обяд. По-късно ще пресечем гъстата джунгла на Юкатан, за да пристигнем в Ривиера Майя. Настаняване в <a className={classes.textLink} href="https://www.bluebayresorts.com/en/hotels/mexico/riviera-maya/playa-del-carmen/bluebay-grand-esmeralda/" target="_blank">Blue Bay Grand Esmeralda 5*</a> на база All inclusive или подобен. Нощувка.</div>
	},
	{
		title: "Ден 9",
		date: "05 декември 2022",
		destination: "Ривиера Майя ",
		others: "(ALL INCLUSIVE)",
		text: <div>Свободен ден на база All inclusive за заслужена почивка.</div>
	},
	{
		title: "Ден 10",
		date: "06 декември 2022",
		destination: "Ривиера Майя ",
		others: "(ALL INCLUSIVE)",
		text: <div>Свободен ден на база All inclusive за почивка. Възможност за допълнителна екскурзия.</div>
	},
	{
		title: "Ден 11",
		date: "07 декември 2022",
		destination: "Ривиера Майя ",
		others: "(ALL INCLUSIVE)",
		text: <div>Свободен ден на база All inclusive за почивка. Възможност за допълнителна екскурзия.</div>
	},
	{
		title: "Ден 12",
		date: "08 / 09 декември 2022",
		destination: "Ривиера Майя – Канкун – Истанбул – София",
		others: "",
		text: <div>Закуска. Трансфер до летище Канкун и полет към Европа. Край на програмата.</div>
	}
];

const otherData = [
    {
		title: "Предимства на нашата програма",
		date: "",
		destination: "",
		others: "",
		text: (
            <div>
                <li>Богата и балансирана програма с качествени услуги с акцент върху историята и културата на Мексико;</li>
                <li>Посещение на 4 от най-важните археологически обекти на Мексико – Теотиуакан, Паленке, Ушмал и Чичен Итца;</li>
                <li>Незабравимо пътуване с лодка из каньона Сумидеро в Чиапас;</li>
                <li>Нощувки във внимателно селектирани хотели;</li>
                <li>Внимание към всеки детайл;</li>
                <li>Отлично екскурзоводско обслужване от местни екскурзоводи с превод на български;</li>
                <li>Опитен водач от България през цялото време, на разположение 24 часа, със страст към дестинацията;</li>
                <li>Пътуване в малка група;</li>
                <li>Допълнителни културни, исторически, социални и други разяснения извън основното екскурзоводско обслужване;</li>
                <li>Допълнителни малки бонуси и изненади по време на пътуването;</li>
                <li>Бързи резервации и потвърждение, както и изчерпателно съдействие с информация за всичко необходимо по организацията на пътуването.</li>
            </div>
        )
	},
	{
		title: "Цената включва",
		date: "",
		destination: "",
		others: "",
		text: (
            <div>
                <div className={classes.bold}>Полети в икономична класа:</div>

                <li>Полет от София до Мексико сити с прекачване в Истанбул, с включени летищни такси, 1 бр. ръчен багаж и 1 бр. чекиран багаж до 23 кг.</li>

                <li>Вътрешен полет: Мексико сити – Тустла Гутиерес, с включени летищни такси, 1 бр. ръчен багаж и 1 бр. чекиран багаж до 23 кг.</li>

                <li>Полет от Канкун до София с прекачване в Истанбул, с включени летищни такси, 1 бр. ръчен багаж и 1 бр. чекиран багаж до 23 кг.</li>
            
                <div className={classes.bold}>11 нощувки в селектирани 4* и 5* хотели в Мексико с включена закуска:</div>
                    
                <li>Мексико сити: 2 нощувки в <a className={classes.textLink} href="https://www.lailahotels.com" target="_blank">Laila Reforma 4*</a> или подобен</li>

                <li>Сан Кристобал де лас Касас: 2 нощувки в <a className={classes.textLink} href="https://www.hotelcasamexicana.com/" target="_blank">Casa Mexicana 4*</a> или подобен</li>

                <li>Паленке: 1 нощувка във <a className={classes.textLink} href="https://www.hotelesvillamercedes.com/en/Menu/Homepage.aspx" target="_blank">Villa Mercedes 4*</a> или подобен</li>

                <li>Кампече: 1 нощувка в <a className={classes.textLink} href="https://hotelplazacampeche.com-hotel.com/" target="_blank">Plaza Campeche 4*</a> или подобен</li>

                <li>Мерида: 1 нощувка в <a className={classes.textLink} href="https://www.wyndhamhotels.com/wyndham/merida-mexico/wyndham-merida/overview" target="_blank"> Wyndham Garden Merida 4*</a> или подобен</li>

                <li>Ривиера Майя: 4 нощувки (на база All inclusive) в <a className={classes.textLink} href="https://www.bluebayresorts.com/en/hotels/mexico/riviera-maya/playa-del-carmen/bluebay-grand-esmeralda/" target="_blank">Blue Bay Grand Esmeralda 5*</a> или подобен</li>

                <div className={classes.bold}>Изхранване:</div>

                <li>11 закуски в избраните хотели + 1 закуска в деня на пристигане (27.11.2022 г.)</li>

                <li>2 обяда без напитки в селектирани ресторанти по програмата</li>

                <li>4 All inclusive</li>

                <div className={classes.bold}>Всички трансфери летище – хотел и обратно, както и самостоятелен транспорт (съобразен с броя на пътуващите в групата) за всички турове описани в програмата.</div>

                <div className={classes.bold}>Всички екскурзии с включени входни такси, описани в програмата:</div>
                
                <li>Мексико сити: панорамна обиколка на центъра – площад Сокало, площада на трите култури, булевард Реформа; парк Чапултепек, Сочимилко. Вход в Антропологическия музей;</li>
                       
                <li>Теотиуакан и Базиликата на Гуадалупе;</li>
                    
                <li>Каньона Сумидеро: екскурзия с моторна лодка;</li>
                    
                <li>Eкскурзия до селищата Сан Хуан Чамула и Синакантан;</li>
                   
                <li>Посещение на Сан Кристобал де лас Касас – вход в Музея на нефрита;</li>
                    
                <li>Паленке: вход в археологическата зона;</li>

                <li>Ескурзия до водопадите Агуа асул;</li>

                <li>Кампече: панорамна обиколка;</li>

                <li>Ушмал: вход в археологическата зона;</li>

                <li>Мерида: панорамна обиколка;</li>

                <li>Чичен Итца: вход в археологическата зона;</li>

                <li>Посещение на сенота Ik-il;</li>

                <div className={classes.bold}>Лицензирани местни екскурзоводи на испански език с превод на български език</div>

                <div className={classes.bold}>Професионален български водач-преводач на място</div>

                <div className={classes.bold}>Медицинска застраховка на ЗК &quot;ЛЕВ ИНС&quot; с покритие 10 000 евро (за лица до 70 г.)</div>
            </div>
        )
	},
    {
		title: "Цената не включва",
		date: "",
		destination: "",
		others: "",
		text: (
            <div>
                <li>Допълнителни хранения извън програмата;</li>

                <li>Напитки по време на включените обяди;</li>

                <li>Такса за щата Кинтана Роо, заплаща се онлайн преди, по време на престоя или при напускане на летището. Към момента (20.04.2022 г.) таксата е в размер на 224 песос (около 10 евро); Препоръчително е да бъде платена преди напускане на щата от този линк https://www.visitax.gob.mx/sitio/. При възможност, моля разпечатайте разписката, за да можете я покажете на летището при поискване;</li>

                <li>Туристическа такса за престой в Плая дел Кармен (около 1 USD на нощувка за всеки турист, заплаща се на рецепция);</li>

                <li>Градски и еко такси в някои от другите хотели, заплащат се на рецепция (около 2 лв на ден);</li>

                <li>Такса за пиколи / носене на куфари при настаняване или напускане на хотелите;</li>

                <li>Допълнителни мероприятия, неописани в програмата;</li>

                <li>Фото и видеотакси за заснемане по туристическите обектите;</li>

                <li>Такса / бакшиш за обслужване от местен екскурзовод/и и шофьор/и (при добро обслужване приблизително до 5 американски долара на ден. Сумата се заплаща на място);</li>

                <li>Разходи от личен характер като интернет, минибар, пиколи и др.;</li>

                <li>Доплащане за избор на седалка, класа в самолетни полети, както и priority check-in;</li>

                <li>Туристически такси за престой в хотел/и от програмата, в случай че е въведена такава между датата на сключване на договор и пътуване. Тази такса се заплаща задължително на място от туристите на рецепцията на всеки хотел.</li>

                <li>Застраховка отмяна на пътуването с “Лев Инс” (възстановява заплатената сума по здравословни и други доказуеми причини);</li>

                <li>Мед. застраховка с покритие 10 000 евро за лица от 70 до 79 г. – доплащане;</li>

                <li>Мед. застраховка с покритие 10 000 евро за лица от 79 до 85 г. – доплащане;</li>

                <li>Тестване или други други документи свързани с акутно заболяване включително Covid-19 (PCR, антигенни тестове и др.);</li>

                <li>Евентуално увеличение на такса гориво и/или летищни такси, дължимо за всички резервации за полети, за които се начислява; </li>

                <li>Туристически такси за престой в хотел/и от програмата, в случай че са въведени такива между датата на сключване на Договор за туристически пакет и пътуването. Тези такси се заплащат задължително на място на рецепция в съответния хотел от всички пътуващи;</li>

                <li>Промяна в цената на международния полет София – Истанбул – Мексико сити и Канкун – Истанбул – София. Към 20.04.2022 г. цената на този маршрут с включени летищни такси, 1 бр. ръчен багаж и 1 бр. чекиран багаж до 23 кг. е 1 650.00 лева на човек. Това е калкулираната сума в общата пакетна цена на екскурзията. При повишаване на тарифата или на размера на летищните такси от страна на превозвача, се начислява доплащане към общата пакетна цена.</li>

                <li>Промяна в цената на вътрешния полет Мексико сити – Тустла Гутиерес. Към 20.04.2022 г. на този маршрут с включени летищни такси, 1 бр. ръчен багаж и 1 бр. чекиран багаж до 23 кг. е 198.00 лева на човек. Това е калкулираната сума в общата пакетна цена на екскурзията. При повишаване на тарифата или на размера на летищните такси от страна на превозвача, се начислява доплащане към общата пакетна цена.</li>
            </div>
        )
	},
    {
		title: "Полетна информация",
		date: "",
		destination: "",
		others: "",
		text: (
            <div>
                <table>
                    <tr>
                        <th>Авиокомпания</th>
                        <th>Полети</th>
                        <th>Дата</th>
                        <th>Дестинации</th>
                        <th>Излитане</th>
                        <th>Кацане</th>
                    </tr>
                    <tr>
                        <td>Търкиш Еърлайнс</td>
                        <td>TK 1030</td>
                        <td>26-11-22</td>
                        <td>София – Истанбул</td>
                        <td>21:25ч.</td>
                        <td>23:50ч.</td>
                    </tr>
                    <tr>
                        <td>Търкиш Еърлайнс</td>
                        <td>TK 184</td>
                        <td>27-11-22</td>
                        <td>Истанбул – Мексико сити</td>
                        <td>02:30ч.</td>
                        <td>08:15ч.</td>
                    </tr>
                    <tr>
                        <td>Воларис</td>
                        <td>Y4 772</td>
                        <td>29-11-22</td>
                        <td>Мексико сити – Тустла Гутиерес</td>
                        <td>07:26ч.</td>
                        <td>09:10ч.</td>
                    </tr>
                    <tr>
                        <td>Търкиш Еърлайнс</td>
                        <td>TK 181</td>
                        <td>08-12-22</td>
                        <td>Канкун – Истанбул</td>
                        <td>14:25ч.</td>
                        <td>
                            <div>10:10 ч.</div>
                            09-12-22
                        </td>
                    </tr>
                    <tr>
                        <td>Търкиш Еърлайнс</td>
                        <td>TK 1031</td>
                        <td>09-12-22</td>
                        <td>Истанбул – София</td>
                        <td>14:55ч.</td>
                        <td>15:10ч.</td>
                    </tr>
                </table>

                <div>
                    <i>*Полетните разписания са информативни и подлежат на препотвърждение. Те могат да бъдат променяни от авиокомпаниите след датата на публикуването им.</i>
                </div>
                
                <i>**Всички полетни разписания са в местно време на съответната дестинация.</i>
            </div>
        )
	},
    {
		title: "Условия за записване и анулиране",
		date: "",
		destination: "",
		others: "",
		text: (
            <div>
                <div className={classes.bold}>Условия за записване:</div>
                <li>Депозит до 3 (три) работни дни от потвърждение на резервацията в размер на 1390.00 лева;</li>
                <li>Окончателно плащане до 31 дни преди датата на заминаване.</li>
                <li>Плащането се извършва в лева по банков път.</li>

                <div className={classes.bold}>Анулации и неустойки:</div>
                <li>До 91 календарни дни (или до) преди датата на пътуването – такса резервация в размер на 50 лв. За всяка промяна след първоначалното записване се удържа такса в размер на 50 лв. Тази сума се дължи, ако пътуващият прекрати / анулира договора си по своя инициатива до 91 дни преди датата на отпътуване;</li>
                <li>От 90 до 61 календарни дни (или до) преди датата на пътуването – 20% от общата сума по договор;</li>
                <li>От 60 до 41 календарни дни (или до) преди датата на пътуването – 50% от общата сума по договор;</li>
                <li>От 40 до 21 календарни дни (или до ) преди датата на пътуването – 80% от общата сума по договор;</li>
                <li>По-малко от 20 календарни дни преди датата на пътуването – 100 % от общата стойност на пакета;</li>
                <li>Преотстъпване на пътуването на друго лице и смяна на име без неустойка – до 31 дни преди заминаване;</li>
                <li>При анулация на пътуването от страна на Туроператора, сумата се възстановява в 7-дневен срок от анулацията;</li>
                <li>При сключена полицата „Отмяна на пътуване“, включително и при положителен PCR тест, сумата се възстановява спрямо Общите условия ЗК &quot;ЛЕВ ИНС&quot;.</li>
            </div>
        )
	},
    {
		title: "Необходими документи",
		date: "",
		destination: "",
		others: "",
		text: (
            <div>
                <li>Задграничен паспорт с валидност минимум 6 месеца след датата на приключване на пътуването;</li>

                <li>Всички туристи до 18 г., пътуващи с един или без родител, нотариална заверка от едния или двамата родители;</li>

                <li>Българските граждани, притежаващи валидни паспорти, могат да влизат и пребивават на територията на Мексико като туристи без визи за срок до 180 дни. В този случай се изисква попълването на миграционен формуляр, който се представя при напускане на страната заедно със задграничен паспорт и билет за обратно връщане. В случай на загубен или откраднат миграционен формуляр трябва да се уведомят компетентните полицейски власти, които издават служебна бележка, удостоверяваща този факт. При напускане на страната българските граждани със загубен, унищожен или откраднат миграционен формуляр заплащат глоба на летищата, която се определя и заплаща в офисите на миграционните власти на съответното летище. Независимо от съществуващия безвизов режим служителите на националната имиграционна служба на Мексико могат по свое решение или по нареждане да направят разширена проверка на влизащите в страната. В този случай пътуващите са отделени от общия поток пътници и с тях в рамките на около 1 час се провеждат два разговора, които мексиканските власти не приемат да се наричат разпити. При установяване на дори и частични непълни съответствия в предоставената от пътника информация или по свое усмотрение имиграционният служител може да откаже достъп до Мексико и да предаде българския гражданин на представители на авиокомпанията – превозвач за връщането му обратно. Мотив за отказа може да бъде неубедителност или непредоставяне на „достатъчно“ документи/доказателства за наличие на предплатен хотел или достатъчни средства за издръжка по време на престоя. При подобни случаи следва да се има предвид, че в промеждутъка между двата разговора българските граждани имат право на консулска защита – т.е. да им бъде предоставена възможност за разговор с консулско длъжностно лице;</li>
            </div>
        )
	},
    {
		title: "Медицински изисквания (към 20.04.2022 г.)",
		date: "",
		destination: "",
		others: "",
		text: (
            <div>
                Без значение до къде и за колко време ще пътувате, моля сверявайте актуалната информация за всяка страната преди резервация и поне още веднъж непосредствено преди самото пътуване. Тя може да претърпи съществена промяна в рамките на съвсем кратки срокове.                

                <li>Не се изисква поставяне на определени ваксини / имунизации;</li>
                
                <li>Не се изискват ПСР тестове или антигенни тестове, за влизане в страната. Въпреки това, при завръщане в България, е възможно да бъдат поискани такива. Също така е възможно авиокомпаниите да изискват ПСР или антигенен тест като условие за качване на борда.</li>
            </div>
        )
	},

    {
		title: "Важно за програмата",
		date: "",
		destination: "",
		others: "",
		text: (
            <div>
                <li>Минимален брой участници: 10;</li>

                <li>Срок за събиране на група и уведомление за несъбран минимум: 61 (шестдесет и един) дни или 26.09.2022 г.;</li>

                <li>Промяна на пакетната цена е възможна при промяна на транспортни разходи (гориво), летищни, пристанищни и други такси; данъчни ставки; промяна с повече от 3% на валутния курс в периода между датата на сключване на договора и отпътуването; непредвидено покачване на цените от страна на партньорите на туроператора, както и в други обективно наложителни случаи. В тези случаи туроператорът може да поиска тези допълнителни разходи да бъдат поети от пътуващия.</li>
               
                <li>Увеличението на цената на пакета, но с не повече от 8 %, вследствие на обективно посочени причини не може да бъде повод за отказ от страна на пътуващия.</li>
                
                <li>Пътуването не е подходящо за лица с ограничена подвижност;</li>

                <li>Посочените пакетни цени са калкулирани при курс на лев към евро 1.00 EUR = 1.95583 BGN;</li>

                <li>Всяка авиокомпания си запазват правото за смяна на часовете на излитане и кацане, за което туроператора ще информира своевременно потребителите;</li>
               
                <li>Туроператорът НЕ носи отговорност при промяна на музейните такси и работното време на музеите. Възможно е да настъпят промени. Туроператорът си запазва правото на промени в последователността на изпълнение на програмата по независещи от него причини и не носи отговорност за туристи, недопуснати от съответните гранични власти;</li>
                
                <li>При възникване на нови промени относно визови, здравни, санитарни и други изисквания, своевременно ще Ви информираме за всички процедури и препоръки касаещи влизането и престоя в Мексико 7 (седем) дни преди отпътуването Ви, с цел максимална точност на информацията;</li>
                
                <li>Туроператорът запазва правото на промяна при необходимост на хотелите упоменати в програмата с подобни от същата категория;</li>
               
                <li>И-Травъл клъб ООД не носи отговорност при въвеждане на нови или повишаване на вече съществуващи държавни такси;</li>
                
                <li>Хотелското настаняване в Мексико обикновено е след 14 часа, а напускането – до 11 часа;</li>
               
                <li>Въпреки усилията на местните власти, в последните години в периода от април до октомври за районите на Ривиера Майя и Канкун се наблюдава засилена концентрация на водорасли тип „sargazo“, които правят голяма част от плажовете практически неизползваеми в рамките на тези периоди. Възможно е това природно явление да се наблюдава, макар и в по-ограничени размери, и извън посочения сезон.</li>

                <div className={classes.bold}>Застраховка „Отмяна от пътуване“:</div>

                <li>Туроператорът предоставя възможност за сключване на допълнителна  застраховка “Отмяна на пътуване” по чл. 80, ал. 1, т.14 от Закона за туризма със ЗАД &quot;Лев Инс&quot;, която е защита в случай на неочаквано възпрепятстване на пътуването от здравословен, служебен или семеен характер, включително Covid-19. Застраховката  покрива разходите за анулиране на пътуването, както и на разходите за заплатени, но неконсумирани услуги по време на пътуването, ако то е било прекъснато. За срокове за сключване и размер на на застрахователната премия, моля обръщайте се към нас по мейл.</li>
                
                <li>Отмяна на пътуването поради COVID-19: Ако застрахованото лице се разболее от COVID-19 или е поставено под карантина поради съмнение за заболяване и следователно трябва да отмени планирано пътуване, застраховката покрива възстановяването на разходите за анулиране на пътуването. Заболяването на съпруг/а или близък роднина, който не пътува, също се счита за причина за анулиране на пътуването, при условие че лицето има животозастрашаващо състояние поради COVID-19 и се нуждае от интензивни грижи в болница.</li>
                
                <li>Други причини за отмяна на пътуването, покрити от застраховката: Включват медицински и немедицински причини, съкращаване от работа и др. описани в Общите условия на застрахователя.</li>

                <div className={classes.bold}>Важни уточнения за събития извън обхвата на застраховките:</div>

                <li>Издадени предупреждения за пътуване, страх за предприемане на пътуване или груба небрежност остават като изключени събития;</li>
                
                <li>Пандемия и епидемия продължават да съществуват като изключения в Общите условия. Например ако пътуването бъде отменено от туроператора заради COVID-19, това събитие е изключен риск по застрахователното покритие;</li>
                
                <li>Пътуване до държави/райони, за които властите са издали официални предупреждения за пътуване (степен 5 или 6);</li>
                
                <li>Отказ за спазване или несъобразяване с правила и разпоредби в дестинацията;</li>
                
                <li>Груба небрежност и умишлено заразяване с COVID-19.</li>
            </div>
        )
	},
    {
		title: "Обща информация за Мексико (към 20.04.2022 г.):",
		date: "",
		destination: "",
		others: "",
		text: (
            <div>
                <li>Местна валута – паричната единица на Мексико е мексиканското песо (MXN). В страната свободно могат да се обменят евро или щатски долари в офисите на банки, обменни бюра, хотели и летища. 1 USD=19.9 MXN, като курсът може да варира според мястото. 1 български лев = приблизително 11 мексикански песос. В туристическите места, като Канкун и Ривиера Майя, е възможно да се плаща и в долари, но курсът е неизгоден. Препоръчително всеки пътуващ да разполага с малка наличност в кеш на евро, щатски долари и местна валута. Ненавсякъде е възможно да се плаща с кредитна или дебитна карта, особено извън туристическите места и големите градове;</li>
                <li>Особености на законодателството – употребата и притежанието на наркотични вещества е федерално престъпление, което подлежи на между 5 и 15 години затвор. Забранена е употребата на алкохол на обществени места, в това число и паркове;</li>
                <li>Митнически изисквания – забранен е вносът на млечни и местни произведения. Допуска се внос на до две бутилки алкохол на човек. Всеки чужденец може да внесе в страната, без да подлежи на деклариране, до 10 000 щатски долара или тяхната равностойност в друга валута. Чужденците са длъжни да пазят миграционната форма, попълнена при влизане в страната и да я предоставят на излизане. При загуба се заплаща глоба. Тази форма се предоставя на борда на самолета или на летището при кацане в Мексико, и се представя на миграционните власти при влизане в страната. Препоръчително е българските граждани да проверят дали при влизане в страната е положен печат в паспорта им. Граждани, в чиито паспорти не е положен този печат, подлежат на глоба;</li>
                <li>Здравеопазване – препоръчва се консумирането само на бутилирана вода. Избягвайте консумацията на напитки с лед в по-евтини заведени, тъй като той се прави от чешмяна вода. Не е желателна консумацията на храни, приготвени на улицата. Плодовете и зеленчуците следва да бъдат измити добре преди консумация. Независимо от липсата на изисквания за задължителни имунизации, в страната има реална опасност от заразяване със зика и денге. Силно препоръчително е туристите да използват препарати против комари в тропическите райони на страната и тези с гъста растителност.</li>
                <li>Сигурност – високи нива на престъпност се регистрира в определени щати на Мексико, породена от водените войни за територия между наркокартели. Сравнително спокойни и безопасни щати са Чиапас, Юкатан, Кинтана Роо, където властите правят всичко възможно, за да гарантират безопасността на туристите. Препоръчително е да се избягват неосветени и безлюдни улици, както и да не се показват скъпи вещи, като смартфони, камери и бижута. Да не се използват таксиметрови услуги без предварителна резервация. Не е препоръчително използването на градски транспорт, поради опасност от джебчии. Препоръчва се по време на престоя в страната да се направи копие от документите за самоличност, а оригиналите следва да се съхраняват на сигурно място. Копието на документ за идентификация се приема от полицейските власти в Мексико. Да се проявява особено внимание по отношение на личните вещи и багаж, най-вече по време на пътуване в обществения транспорт. Пътуването на „автостоп” следва да се избягва.</li>
                <li>Климат – от май до ноември е периодът на дъждовете, съпроводени с ураганни ветрове, особено по крайбрежието на Мексиканския залив и района на Ривиера Майя. През декември температурите в столицата варират от 7 до 20°C, като са възможни дъждове. Градът е на голяма надморска височина, около 2 300 метра, и са възможни трудности при аклиматизацията. За същия период температурите в Чиапас са между 15-27°C, като е възможно да вали почти всеки ден. В Сан Кристобал нощите са студени, а утрините мъгливи, с температури около 7-8°C, което се дължи на планинския му релеф. В щата Кинтана Роо, където са разположени Канкун и Ривиера Майя, декември е един от най-подходящите периоди за посещение. Температурите са сравнително постоянни за целия месец и са около 30°C максимална и 18°C минимална температура. Възможни са внезапни и краткотрайни, но напоителни тропически дъждове. Като цяло, пригответе връхни дрехи, чадър, дъждобран, репелент против комари и слънцезащитен крем. Не забравяйте удобните обувки и сандали.</li>
                <li>Електрическо напрежение, контакти и нужда от адаптор § преходник – в Мексико напрежението е 127V. Контактите са тип А и В. За използването на електронни устройства от България е необходим адаптор § преходник на напрежение. Моля убедете се предварително, че Вашето устройство може да работи на местното напрежение.</li>
                <li>Часовата разлика между България и Мексико в по-голямата част от страната е – 8 часа. Щата Кинтана Роо не сменя лятното време.</li>
                <li>За повече информация може да разгледате секцията „Пътувам за ...“ на българското Министерство на външните работи и да се запознаете с дадените препоръки за Мексико.</li>
            </div>
        )
	}
]

const images = [
    {
        title:"Trajineras",
        small:"https://etclub.bg/images/mexico-11-2022/trajineras-small.jpeg",
        large:"https://etclub.bg/images/mexico-11-2022/trajineras-large.jpeg"
    },
    {
        title:"Palacio de bellas artes",
        small:"https://etclub.bg/images/mexico-11-2022/palacio-de-bellas-artes-small.jpg",
        large:"https://etclub.bg/images/mexico-11-2022/palacio-de-bellas-artes-large.jpg"
    },
    {
        title:"Sumidero",
        small:"https://etclub.bg/images/mexico-11-2022/gabriel-tovar-iBzAIkuOFiY-unsplash-small.jpeg",
        large:"https://etclub.bg/images/mexico-11-2022/gabriel-tovar-iBzAIkuOFiY-unsplash-large.jpeg"
    },
    {
        title:"Chichen-itza",
        small:"https://etclub.bg/images/mexico-11-2022/chichenitza-tower-small.jpg",
        large:"https://etclub.bg/images/mexico-11-2022/chichenitza-tower-large.jpg"
    },
    {
        title:"San Cristobal de las casas",
        small:"https://etclub.bg/images/mexico-11-2022/guido-hn-d4U5dpVC1pk-unsplash-small.jpeg",
        large:"https://etclub.bg/images/mexico-11-2022/guido-hn-d4U5dpVC1pk-unsplash-large.jpeg"
    },
    {
        title:"Cenote",
        small:"https://etclub.bg/images/mexico-11-2022/cenote-small.jpg",
        large:"https://etclub.bg/images/mexico-11-2022/cenote-large.jpg"
    },
    {
        title:"Palenque",
        small:"https://etclub.bg/images/mexico-11-2022/mexico-ga6625aa46_640.jpg",
        large:"https://etclub.bg/images/mexico-11-2022/mexico-gcc080a4ea_1920.jpg"
    },
    {
        title:"Playa",
        small:"https://etclub.bg/images/mexico-11-2022/playa-4-small.jpg",
        large:"https://etclub.bg/images/mexico-11-2022/playa-4-large.jpg"
    },
    {
        title:"Uxmal",
        small:"https://etclub.bg/images/mexico-11-2022/pyramid-g47f417014_640.jpg",
        large:"https://etclub.bg/images/mexico-11-2022/pyramid-g1e53a6549_1920.jpg"
    },
    {
        title:"Ik-il",
        small:"https://etclub.bg/images/mexico-11-2022/ik-il-small.jpeg",
        large:"https://etclub.bg/images/mexico-11-2022/ik-il-large.jpeg"
    }
]
const OfferMexico = () => {

	return (
		<div className={classes.offerWrapper}>
            <div className={classes.galleryWrapper}>
                    {
                        images.map((image, index) => (
                            <ModalImage
                                key={`image-${index}`}
                                small={image.small}
                                large={image.large}
                                alt={image.title}
                            />
                        ))
                    }
            </div>

            <div className={classes.programWrapper}>
                <div className={classes.description}>
                    <div className={classes.descriptionSection}>


                    <h1 className={classes.title}>Viva México! – От Чиапас до Юкатан</h1>
                    <h2 className={classes.subTitle}>Мексико</h2>
                    <h2 className={classes.subTitleDate}>26.11.2022 - 09.12.2022</h2>

                    <h3>Защо да изберете Мексико?</h3>

                    <div>
                        Мексико е родено от една силна любов, тази на Ернан Кортес и индианката Малинче. И няма как да е
                        иначе, само любовта ражда любов. В тази държава човек не може да не се влюби. И най-коравото сърце
                        не може да устои на внушителните вулкани, топлите джунгли, искрените и дружелюбни хора,
                        огромното разнообразие от храна и колосалното културно наследство. Тук въздухът е различен, мек, с
                        аромат на пури и южен вятър, а любовта е навсякъде. Да посети Мексико поне веднъж в живота си е
                        задължение на всеки себеуважаващ се пътешественик. Мексико иска още и още, това е държава, която
                        вечно те зове. Позволете си това приключение и почувствайте очарованието на тази вълшебна страна. За
                        Вас изготвихме вълнуваща програма, с която ще Ви покажем най-важните забележителности, но преди
                        всичко ще усетите духа на магията, наречено Мексико. Гарантираме Ви, ще искате да се връщате пак и
                        пак. Мексико е опасно място. Води до пристрастяване и обикновено завършва с любов. Имате ли куража
                        да поемете този риск? Ако сте достатъчно смели, значи сте нашите хора. Заминаваме заедно!
                    </div>

                    <div className={classes.bold}>
                        Приключението е гарантирано!
                    </div>

                    <div className={classes.priceRow}>
                        Цена: 

                        <span className={classes.notdiscounted}> 6145лв </span>

                        <span className={classes.discounted}>5799лв</span>
                    </div>
                    </div>
			        {
			        	otherData.map((dayInfo, index) => (
                            <CollapseSectionSimple
                                key={index}
                                day={dayInfo.title}
                                date={dayInfo.date}
                                title={dayInfo.destination + dayInfo.others}
                                content={dayInfo.text}    
                            />
                        ))
			        }   
                </div>

                <div className={classes.program}>
			        {
			        	data.map((dayInfo, index) => (
                            <CollapseSectionSimple
                                key={index}
                                day={dayInfo.title}
                                date={dayInfo.date}
                                title={dayInfo.destination + dayInfo.others}
                                content={dayInfo.text}    
                            />
                        ))
			        }
                </div>

                { null && (
                    <div>
			            {
			            	data.map((dayInfo, index) => (
                                    <CollapseSection
                                    key={index}
                                    day={dayInfo.title.substring(4)}
                                    date={dayInfo.date}
                                    title={dayInfo.destination + dayInfo.others}
                                    content={dayInfo.text}    
                                />
                            ))
			            }
                    </div>
                )
                }
            </div>
		</div>
	)

}

export default OfferMexico;
